import { createContext, useContext, useState, useCallback } from "react";
import Modal from "@components/modal.res";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState(null);
  const [modalProps, setModalProps] = useState({}); // ALWAYS OBJECT

  const openModal = useCallback((component, props = {}) => {
    setContent(component);
    setModalProps(props);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setContent(null);
    setModalProps({});
  }, []);

  return (
    <ModalContext.Provider
      value={{
        isOpen,
        content,
        openModal,
        closeModal,
        setModalProps,
      }}
    >
      {children}

      <Modal isOpen={isOpen} onClose={closeModal} {...modalProps}>
        {content}
      </Modal>
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
